export const DepotTypes = [
  { key: "in", value: "ورودی" },
  { key: "out", value: "خروجی" },
];
